import { render, staticRenderFns } from "./VoyageReview.vue?vue&type=template&id=123178fa&"
import script from "./VoyageReview.vue?vue&type=script&lang=js&"
export * from "./VoyageReview.vue?vue&type=script&lang=js&"
import style0 from "./VoyageReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VoyageReview.vue"
export default component.exports